const map = {
	"./apparel/image2.png": 29193,
	"./bulk-registration-service/image2.png": 64164,
	"./cruise/image2.png": 56325,
	"./daiyu/image2.png": 97768,
	"./hakirei-cms/image2.png": 11617,
	"./iot-camera-system/image2.png": 84358,
	"./kenjaya/image2.png": 8729,
	"./liberty/image2.png": 46471,
	"./line/image2.png": 21244,
	"./n-plus/image2.png": 815,
	"./payment-service/image2.png": 60412,
	"./realestate/image2.png": 65042,
	"./rss/image2.png": 28032,
	"./shoemaker-web/image2.png": 82322,
	"./shoemaker/image2.png": 69073,
	"./techrise/image2.png": 55607,
	"./token-news/image2.png": 64441,
	"./wwx/image2.png": 31286
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83655;